// tslint:disable
export var MemberNumberType;
(function (MemberNumberType) {
    // If Membernumber type is Unknown
    MemberNumberType[MemberNumberType["Unknown"] = 0] = "Unknown";
    // Medical MemberNumber
    MemberNumberType[MemberNumberType["Medical"] = 6] = "Medical";
    // Pharmacy MemberNumber
    MemberNumberType[MemberNumberType["Pharmacy"] = 7] = "Pharmacy";
})(MemberNumberType || (MemberNumberType = {}));
MemberNumberType['UNKNOWN'] = 0;
MemberNumberType['MEDICAL'] = 6;
MemberNumberType['PHARMACY'] = 7;
//# sourceMappingURL=MemberNumberType.js.map